export default __webpack_public_path__ + "static/assets/aaf5c91ab54d117ed085a10e361c6413.jpg";